import { render, staticRenderFns } from "./tiendas.vue?vue&type=template&id=b3e2adf6&scoped=true&"
import script from "./tiendas.vue?vue&type=script&lang=js&"
export * from "./tiendas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3e2adf6",
  null
  
)

export default component.exports